import pathfinder from '@fiverr-private/pathfinder';
import { MOBILE_COPY_SUFFIX, QUICK_ACTIONS_COPY_PREFIX } from './constants';

export const CONTACT_SALES_URL = pathfinder('fbs_contact_us_page');

export const getCopyKey = (key: string, isMobileCopy: boolean) =>
    `${QUICK_ACTIONS_COPY_PREFIX}.${key}${isMobileCopy ? MOBILE_COPY_SUFFIX : ''}`;
